document.querySelectorAll('[data-br-brain-energy-end]').forEach((root) => {
  const dock = root.querySelector('.br-brain-energy-end__dock');
  const hero = document.querySelector('.br-brain-energy-hero');
  const link = dock?.querySelector('a');
  if (!dock || !hero || !link) return;
  let heroOut = false;
  let closeIn = false;
  const update = () => {
    const visible = heroOut && !closeIn;
    dock.dataset.visible = String(visible);
    dock.setAttribute('aria-hidden', String(!visible));
    link.tabIndex = visible ? 0 : -1;
  };
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      heroOut = !entry.isIntersecting;
      update();
    }).observe(hero);
    new IntersectionObserver(
      ([entry]) => {
        closeIn = entry.isIntersecting;
        update();
      },
      { threshold: 0.25 }
    ).observe(root.querySelector('.br-brain-energy-end__card'));
  } else {
    heroOut = true;
  }
  window.addEventListener('resize', update);
  update();
});
